// extracted by mini-css-extract-plugin
module.exports = {"termsAndConditions":"TermsAndConditions_termsAndConditions__yBxOd"};